import { z } from 'zod';

export const createNvrBody = z.object({
  name: z.string().min(1),
  ipAddress: z.string().min(1),
  onvifPort: z.string().min(1),
  rtspPort: z.string().min(1),
  httpPort: z.string().optional(),
  username: z.string().min(1),
  password: z.string().min(1),
  patientId: z.uuid(),
});
export type CreateNvrBody = z.infer<typeof createNvrBody>;

export const updateNvrBody = z.object({
  name: z.string().min(1).optional(),
  ipAddress: z.string().min(1).optional(),
  rtspPort: z.string().min(1).optional(),
  onvifPort: z.string().min(1).optional(),
  httpPort: z.string().optional(),
  username: z.string().min(1).optional(),
  password: z.string().min(1).optional(),
  patientId: z.uuid(),
});
export type UpdateNvrBody = z.infer<typeof updateNvrBody>;

export const nvrIdParam = z.object({ id: z.uuid() });
export type NvrIdParam = z.infer<typeof nvrIdParam>;
